import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * The JSM Custom Journey Type Route.
 * Custom Journey Type: /jira/servicedesk/projects/:projectKey/journeys/pending/:journeyTypeId
 */
export const customJourneyTypeRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/journeys/pending/:journeyTypeId',
	name: 'journey-type',
	exact: true,
};
